import axios from "axios";
import { BASE_URL } from "../../../helpers/config.js";
import authorizedAxios from "../../../helpers/authorizedAxios";
import { showToast } from "../../../utils/helpers/ShowToast";
import PATH_URL from "../../../routers/path.js";
import { clearActiveOutlet, synchronizeActiveOutlet } from "../../../utils/helpers/outletContext.js";
export const SET_LOGIN = "SET_LOGIN";
export const SET_LOGIN_LOADING = "SET_LOGIN_LOADING";
export const SET_LOGIN_ERROR = "SET_LOGIN_ERROR";
export const SET_AUTH_SESSION = "SET_AUTH_SESSION";
export const SET_USER_PROFILE = "SET_USER_PROFILE";
export const CLEAR_AUTH_SESSION = "CLEAR_AUTH_SESSION";

const apiHeaders = {
  Accept: "application/json",
  "X-Requested-With": "XMLHttpRequest",
};

export const fetchUserProfile = () => {
  return async (dispatch) => {
    dispatch({ type: SET_LOGIN_LOADING, status: true });
    try {
      const response = await authorizedAxios.get("/me");

      if (response.status === 200 || response.status === 201) {
        const profile = response?.data?.data;
        synchronizeActiveOutlet(profile);
        localStorage.setItem("userProfile", JSON.stringify(profile));
        dispatch({ type: SET_USER_PROFILE, profile });
      }
    } catch (error) {
      localStorage.removeItem("userProfile");
      dispatch({ type: SET_USER_PROFILE, profile: null });
      dispatch({ type: "FETCH_USER_PROFILE_FAILED", error: error.message });
    } finally {
      dispatch({ type: SET_LOGIN_LOADING, status: false });
    }
  };
};

const appendIfExists = (formData, key, value) => {
  if (value !== undefined && value !== null && value !== "") {
    formData.append(key, value);
  }
};

const buildProfileFormData = (data) => {
  const formData = new FormData();
  formData.append("_method", "PUT");

  ["name", "username", "email", "phone", "current_password", "password", "password_confirmation"].forEach((field) =>
    appendIfExists(formData, field, data?.[field]),
  );
  appendIfExists(formData, "image", data?.image_file);

  return formData;
};

export const updateUserProfile = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOGIN_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post("/me", buildProfileFormData(data)), {
        loading: "Memperbarui profil...",
        success: "Profil akun berhasil diperbarui!",
        error: (err) => err?.response?.data?.message || "Gagal memperbarui profil akun!",
      });

      const profile = response?.data?.data || response?.data;
      if (profile && typeof profile === "object") {
        localStorage.setItem("userProfile", JSON.stringify(profile));
        dispatch({ type: SET_USER_PROFILE, profile });
      }

      await dispatch(fetchUserProfile());
      return true;
    } catch (error) {
      dispatch({
        type: SET_LOGIN_ERROR,
        error: error?.response?.data?.message || error?.message || "Terjadi kesalahan.",
      });
      return false;
    } finally {
      dispatch({ type: SET_LOGIN_LOADING, status: false });
    }
  };
};

export const login = (data, navigate) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOGIN_LOADING, status: true });
    try {
      const payload = {
        ...data,
        email: String(data?.email || data?.username || "").trim(),
        username: String(data?.username || data?.email || "").trim(),
        password: data?.password || "",
      };

      const response = await showToast(axios.post(`${BASE_URL}/login`, payload, { headers: apiHeaders }), {
        loading: "Login...",
        success: "Berhasil Login",
        error: (err) => {
          if (err?.response?.status === 429) {
            return "Terlalu banyak percobaan login. Tunggu sebentar lalu coba lagi.";
          }

          return err?.response?.data?.message || "Gagal Login!";
        },
      });

      if (response.status === 200 || response.status === 201) {
        const auth = response?.data?.data;

        clearActiveOutlet();
        localStorage.setItem("auth", JSON.stringify(auth));
        dispatch({ type: SET_AUTH_SESSION, auth });
        await dispatch(fetchUserProfile());

        if (typeof navigate === "function") {
          navigate(PATH_URL.DASHBOARD, { replace: true });
        }
      }
    } catch (error) {
      localStorage.removeItem("auth");
      dispatch({ type: CLEAR_AUTH_SESSION });
      dispatch({
        type: SET_LOGIN_ERROR,
        error:
          error?.response?.status === 429
            ? "Terlalu banyak percobaan login. Tunggu sebentar lalu coba lagi."
            : error?.response?.data?.message || error?.message || "Terjadi kesalahan.",
      });
    } finally {
      dispatch({ type: SET_LOGIN_LOADING, status: false });
    }
  };
};

export const logout = () => {
  return (dispatch) => {
    localStorage.removeItem("auth");
    localStorage.removeItem("userProfile");
    clearActiveOutlet();
    dispatch({ type: CLEAR_AUTH_SESSION });
  };
};

export const verivyToken = (token, navigate) => {
  return async (dispatch) => {
    dispatch({ type: SET_LOGIN_LOADING, status: true });
    try {
      const response = await showToast(axios.get(`${BASE_URL}/verify-account-kemenag?token=` + token, { headers: apiHeaders }), {
        loading: "Verivy token...",
        success: "Berhasil verivy token",
        error: (err) => err?.response?.message || "Gagal verivy token!",
      });

      if (response.status === 200 || response.status === 201) {
        const auth = response?.data?.data;
        localStorage.setItem("auth", JSON.stringify(auth));
        dispatch({ type: SET_AUTH_SESSION, auth });
        await dispatch(fetchUserProfile());
        if (typeof navigate === "function") {
          navigate(PATH_URL.DASHBOARD, { replace: true });
        }
      }
    } catch (error) {
      localStorage.removeItem("auth");
      dispatch({ type: CLEAR_AUTH_SESSION });
      const errorMessage = error?.response?.data?.message || error?.message || "Terjadi kesalahan.";
      localStorage.setItem("verivyErrorMessage", errorMessage);
      dispatch({
        type: SET_LOGIN_ERROR,
        error: error?.message || "Terjadi kesalahan.",
      });
      if (typeof navigate === "function") {
        navigate("/login", { replace: true });
      }
    } finally {
      dispatch({ type: SET_LOGIN_LOADING, status: false });
    }
  };
};
